import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import ScrollToTop from "./components/ScrollToTop";
import Layout from "./components/Layout";
import Index from "./pages/Index";
import Contact from "./pages/Contact";
import About from "./pages/About";
import FAQ from "./pages/FAQ";
import Process from "./pages/Process";
import Services from "./pages/Services";
import Asphalt from "./pages/services/Asphalt";
import Metal from "./pages/services/Metal";
import Repair from "./pages/services/Repair";
import Replacement from "./pages/services/Replacement";
import StormDamage from "./pages/services/StormDamage";
import Commercial from "./pages/services/Commercial";
import Inspections from "./pages/services/Inspections";
import Eavestrough from "./pages/services/Eavestrough";
import Areas from "./pages/Areas";
import Saskatoon from "./pages/areas/Saskatoon";
import SaskatoonStormDamage from "./pages/areas/SaskatoonStormDamage";
import SaskatoonInspection from "./pages/areas/SaskatoonInspection";
import SaskatoonAsphalt from "./pages/areas/SaskatoonAsphalt";
import SaskatoonMetal from "./pages/areas/SaskatoonMetal";
import SaskatoonCommercial from "./pages/areas/SaskatoonCommercial";
import SaskatoonReplacement from "./pages/areas/SaskatoonReplacement";
import SaskatoonRepair from "./pages/areas/SaskatoonRepair";
import Regina from "./pages/areas/Regina";
import ReginaStormDamage from "./pages/areas/ReginaStormDamage";
import ReginaInspection from "./pages/areas/ReginaInspection";
import ReginaAsphalt from "./pages/areas/ReginaAsphalt";
import ReginaMetal from "./pages/areas/ReginaMetal";
import ReginaCommercial from "./pages/areas/ReginaCommercial";
import ReginaReplacement from "./pages/areas/ReginaReplacement";
import ReginaRepair from "./pages/areas/ReginaRepair";
import MooseJaw from "./pages/areas/MooseJaw";
import MooseJawStormDamage from "./pages/areas/MooseJawStormDamage";
import MooseJawInspection from "./pages/areas/MooseJawInspection";
import MooseJawAsphalt from "./pages/areas/MooseJawAsphalt";
import MooseJawMetal from "./pages/areas/MooseJawMetal";
import MooseJawCommercial from "./pages/areas/MooseJawCommercial";
import PrinceAlbert from "./pages/areas/PrinceAlbert";
import PrinceAlbertStormDamage from "./pages/areas/PrinceAlbertStormDamage";
import PrinceAlbertInspection from "./pages/areas/PrinceAlbertInspection";
import PrinceAlbertAsphalt from "./pages/areas/PrinceAlbertAsphalt";
import PrinceAlbertMetal from "./pages/areas/PrinceAlbertMetal";
import PrinceAlbertCommercial from "./pages/areas/PrinceAlbertCommercial";
import SwiftCurrent from "./pages/areas/SwiftCurrent";
import SwiftCurrentStormDamage from "./pages/areas/SwiftCurrentStormDamage";
import SwiftCurrentInspection from "./pages/areas/SwiftCurrentInspection";
import SwiftCurrentAsphalt from "./pages/areas/SwiftCurrentAsphalt";
import SwiftCurrentMetal from "./pages/areas/SwiftCurrentMetal";
import SwiftCurrentCommercial from "./pages/areas/SwiftCurrentCommercial";
import Yorkton from "./pages/areas/Yorkton";
import YorktonStormDamage from "./pages/areas/YorktonStormDamage";
import YorktonInspection from "./pages/areas/YorktonInspection";
import YorktonAsphalt from "./pages/areas/YorktonAsphalt";
import YorktonMetal from "./pages/areas/YorktonMetal";
import YorktonCommercial from "./pages/areas/YorktonCommercial";
import Estevan from "./pages/areas/Estevan";
import EstevanStormDamage from "./pages/areas/EstevanStormDamage";
import EstevanInspection from "./pages/areas/EstevanInspection";
import EstevanAsphalt from "./pages/areas/EstevanAsphalt";
import EstevanMetal from "./pages/areas/EstevanMetal";
import EstevanCommercial from "./pages/areas/EstevanCommercial";
import Weyburn from "./pages/areas/Weyburn";
import WeyburnStormDamage from "./pages/areas/WeyburnStormDamage";
import WeyburnInspection from "./pages/areas/WeyburnInspection";
import WeyburnAsphalt from "./pages/areas/WeyburnAsphalt";
import WeyburnMetal from "./pages/areas/WeyburnMetal";
import WeyburnEavestrough from "./pages/areas/WeyburnEavestrough";
import SaskatoonEavestrough from "./pages/areas/SaskatoonEavestrough";
import ReginaEavestrough from "./pages/areas/ReginaEavestrough";
import MooseJawEavestrough from "./pages/areas/MooseJawEavestrough";
import PrinceAlbertEavestrough from "./pages/areas/PrinceAlbertEavestrough";
import SwiftCurrentEavestrough from "./pages/areas/SwiftCurrentEavestrough";
import YorktonEavestrough from "./pages/areas/YorktonEavestrough";
import EstevanEavestrough from "./pages/areas/EstevanEavestrough";
import WeyburnCommercial from "./pages/areas/WeyburnCommercial";
import MooseJawReplacement from "./pages/areas/MooseJawReplacement";
import PrinceAlbertReplacement from "./pages/areas/PrinceAlbertReplacement";
import SwiftCurrentReplacement from "./pages/areas/SwiftCurrentReplacement";
import YorktonReplacement from "./pages/areas/YorktonReplacement";
import EstevanReplacement from "./pages/areas/EstevanReplacement";
import WeyburnReplacement from "./pages/areas/WeyburnReplacement";
import MooseJawRepair from "./pages/areas/MooseJawRepair";
import PrinceAlbertRepair from "./pages/areas/PrinceAlbertRepair";
import SwiftCurrentRepair from "./pages/areas/SwiftCurrentRepair";
import YorktonRepair from "./pages/areas/YorktonRepair";
import EstevanRepair from "./pages/areas/EstevanRepair";
import WeyburnRepair from "./pages/areas/WeyburnRepair";
import NotFound from "./pages/NotFound";
import Financing from "./pages/Financing";
import CommercialB2B from "./pages/CommercialB2B";
import CalculatorPage from "./pages/CalculatorPage";
import RoofingCostGuideSaskatchewan from "./pages/RoofingCostGuideSaskatchewan";
import Blog from "./pages/Blog";
import SaskatchewanRoofingCostGuide from "./pages/blog/SaskatchewanRoofingCostGuide";
import HailDamageRoofRepairSaskatchewan from "./pages/blog/HailDamageRoofRepairSaskatchewan";
import IceDammingSaskatchewan from "./pages/blog/IceDammingSaskatchewan";
import MetalVsAsphaltSaskatchewan from "./pages/blog/MetalVsAsphaltSaskatchewan";
import HowToChooseRoofingContractorSaskatchewan from "./pages/blog/HowToChooseRoofingContractorSaskatchewan";
import RoofReplacementProcessStepByStep from "./pages/blog/RoofReplacementProcessStepByStep";
import SaskatchewanRoofingPermitsGuide from "./pages/blog/SaskatchewanRoofingPermitsGuide";
import SignsYouNeedRoofReplacement from "./pages/blog/SignsYouNeedRoofReplacement";

const queryClient = new QueryClient();

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Index />} />
              <Route path="contact" element={<Contact />} />
              <Route path="about" element={<About />} />
              <Route path="process" element={<Process />} />
              <Route path="faq" element={<FAQ />} />
              <Route path="calculator" element={<CalculatorPage />} />
              <Route path="services" element={<Services />} />
              <Route path="services/asphalt" element={<Asphalt />} />
              <Route path="services/metal" element={<Metal />} />
              <Route path="services/repair" element={<Repair />} />
              <Route path="services/replacement" element={<Replacement />} />
              <Route path="services/storm-damage" element={<StormDamage />} />
              <Route path="services/commercial" element={<Commercial />} />
              <Route path="services/inspections" element={<Inspections />} />
              <Route path="services/eavestrough" element={<Eavestrough />} />
              <Route path="areas" element={<Areas />} />
              <Route path="areas/saskatoon" element={<Saskatoon />} />
              <Route
                path="areas/saskatoon/storm-damage"
                element={<SaskatoonStormDamage />}
              />
              <Route
                path="areas/saskatoon/inspection"
                element={<SaskatoonInspection />}
              />
              <Route
                path="areas/saskatoon/asphalt"
                element={<SaskatoonAsphalt />}
              />
              <Route
                path="areas/saskatoon/metal"
                element={<SaskatoonMetal />}
              />
              <Route
                path="areas/saskatoon/commercial"
                element={<SaskatoonCommercial />}
              />
              <Route
                path="areas/saskatoon/replacement"
                element={<SaskatoonReplacement />}
              />
              <Route
                path="areas/saskatoon/repair"
                element={<SaskatoonRepair />}
              />
              <Route path="areas/regina" element={<Regina />} />
              <Route
                path="areas/regina/storm-damage"
                element={<ReginaStormDamage />}
              />
              <Route
                path="areas/regina/inspection"
                element={<ReginaInspection />}
              />
              <Route path="areas/regina/asphalt" element={<ReginaAsphalt />} />
              <Route path="areas/regina/metal" element={<ReginaMetal />} />
              <Route
                path="areas/regina/commercial"
                element={<ReginaCommercial />}
              />
              <Route
                path="areas/regina/replacement"
                element={<ReginaReplacement />}
              />
              <Route path="areas/regina/repair" element={<ReginaRepair />} />
              <Route path="areas/moose-jaw" element={<MooseJaw />} />
              <Route
                path="areas/moose-jaw/storm-damage"
                element={<MooseJawStormDamage />}
              />
              <Route
                path="areas/moose-jaw/inspection"
                element={<MooseJawInspection />}
              />
              <Route
                path="areas/moose-jaw/asphalt"
                element={<MooseJawAsphalt />}
              />
              <Route path="areas/moose-jaw/metal" element={<MooseJawMetal />} />
              <Route
                path="areas/moose-jaw/commercial"
                element={<MooseJawCommercial />}
              />
              <Route path="areas/prince-albert" element={<PrinceAlbert />} />
              <Route
                path="areas/prince-albert/storm-damage"
                element={<PrinceAlbertStormDamage />}
              />
              <Route
                path="areas/prince-albert/inspection"
                element={<PrinceAlbertInspection />}
              />
              <Route
                path="areas/prince-albert/asphalt"
                element={<PrinceAlbertAsphalt />}
              />
              <Route
                path="areas/prince-albert/metal"
                element={<PrinceAlbertMetal />}
              />
              <Route
                path="areas/prince-albert/commercial"
                element={<PrinceAlbertCommercial />}
              />
              <Route path="areas/swift-current" element={<SwiftCurrent />} />
              <Route
                path="areas/swift-current/storm-damage"
                element={<SwiftCurrentStormDamage />}
              />
              <Route
                path="areas/swift-current/inspection"
                element={<SwiftCurrentInspection />}
              />
              <Route
                path="areas/swift-current/asphalt"
                element={<SwiftCurrentAsphalt />}
              />
              <Route
                path="areas/swift-current/metal"
                element={<SwiftCurrentMetal />}
              />
              <Route
                path="areas/swift-current/commercial"
                element={<SwiftCurrentCommercial />}
              />
              <Route path="areas/yorkton" element={<Yorkton />} />
              <Route
                path="areas/yorkton/storm-damage"
                element={<YorktonStormDamage />}
              />
              <Route
                path="areas/yorkton/inspection"
                element={<YorktonInspection />}
              />
              <Route
                path="areas/yorkton/asphalt"
                element={<YorktonAsphalt />}
              />
              <Route path="areas/yorkton/metal" element={<YorktonMetal />} />
              <Route
                path="areas/yorkton/commercial"
                element={<YorktonCommercial />}
              />
              <Route path="areas/estevan" element={<Estevan />} />
              <Route
                path="areas/estevan/storm-damage"
                element={<EstevanStormDamage />}
              />
              <Route
                path="areas/estevan/inspection"
                element={<EstevanInspection />}
              />
              <Route
                path="areas/estevan/asphalt"
                element={<EstevanAsphalt />}
              />
              <Route path="areas/estevan/metal" element={<EstevanMetal />} />
              <Route
                path="areas/estevan/commercial"
                element={<EstevanCommercial />}
              />
              <Route path="areas/weyburn" element={<Weyburn />} />
              <Route
                path="areas/weyburn/storm-damage"
                element={<WeyburnStormDamage />}
              />
              <Route
                path="areas/weyburn/inspection"
                element={<WeyburnInspection />}
              />
              <Route
                path="areas/weyburn/asphalt"
                element={<WeyburnAsphalt />}
              />
              <Route path="areas/weyburn/metal" element={<WeyburnMetal />} />
              <Route
                path="areas/weyburn/commercial"
                element={<WeyburnCommercial />}
              />
              <Route
                path="areas/saskatoon/eavestrough"
                element={<SaskatoonEavestrough />}
              />
              <Route
                path="areas/regina/eavestrough"
                element={<ReginaEavestrough />}
              />
              <Route
                path="areas/moose-jaw/eavestrough"
                element={<MooseJawEavestrough />}
              />
              <Route
                path="areas/prince-albert/eavestrough"
                element={<PrinceAlbertEavestrough />}
              />
              <Route
                path="areas/swift-current/eavestrough"
                element={<SwiftCurrentEavestrough />}
              />
              <Route
                path="areas/yorkton/eavestrough"
                element={<YorktonEavestrough />}
              />
              <Route
                path="areas/estevan/eavestrough"
                element={<EstevanEavestrough />}
              />
              <Route
                path="areas/weyburn/eavestrough"
                element={<WeyburnEavestrough />}
              />
              <Route
                path="areas/moose-jaw/replacement"
                element={<MooseJawReplacement />}
              />
              <Route
                path="areas/prince-albert/replacement"
                element={<PrinceAlbertReplacement />}
              />
              <Route
                path="areas/swift-current/replacement"
                element={<SwiftCurrentReplacement />}
              />
              <Route
                path="areas/yorkton/replacement"
                element={<YorktonReplacement />}
              />
              <Route
                path="areas/estevan/replacement"
                element={<EstevanReplacement />}
              />
              <Route
                path="areas/weyburn/replacement"
                element={<WeyburnReplacement />}
              />
              <Route
                path="areas/moose-jaw/repair"
                element={<MooseJawRepair />}
              />
              <Route
                path="areas/prince-albert/repair"
                element={<PrinceAlbertRepair />}
              />
              <Route
                path="areas/swift-current/repair"
                element={<SwiftCurrentRepair />}
              />
              <Route path="areas/yorkton/repair" element={<YorktonRepair />} />
              <Route path="areas/estevan/repair" element={<EstevanRepair />} />
              <Route path="areas/weyburn/repair" element={<WeyburnRepair />} />
              <Route path="blog" element={<Blog />} />
              <Route
                path="blog/saskatchewan-roofing-cost-guide"
                element={<SaskatchewanRoofingCostGuide />}
              />
              <Route
                path="blog/hail-damage-roof-repair-saskatchewan"
                element={<HailDamageRoofRepairSaskatchewan />}
              />
              <Route
                path="blog/ice-damming-saskatchewan"
                element={<IceDammingSaskatchewan />}
              />
              <Route
                path="blog/metal-vs-asphalt-roofing-saskatchewan"
                element={<MetalVsAsphaltSaskatchewan />}
              />
              <Route
                path="blog/how-to-choose-roofing-contractor-saskatchewan"
                element={<HowToChooseRoofingContractorSaskatchewan />}
              />
              <Route
                path="blog/roof-replacement-process-step-by-step"
                element={<RoofReplacementProcessStepByStep />}
              />
              <Route
                path="blog/saskatchewan-roofing-permits-guide"
                element={<SaskatchewanRoofingPermitsGuide />}
              />
              <Route
                path="blog/signs-you-need-roof-replacement"
                element={<SignsYouNeedRoofReplacement />}
              />
              <Route path="financing" element={<Financing />} />
              <Route path="commercial" element={<CommercialB2B />} />
              <Route
                path="roofing-cost-guide-saskatchewan"
                element={<RoofingCostGuideSaskatchewan />}
              />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
